import { EventEmitter } from '@angular/core';
var XomAdminMessageComponent = /** @class */ (function () {
    function XomAdminMessageComponent() {
        this.close = new EventEmitter(null);
    }
    return XomAdminMessageComponent;
}());
export { XomAdminMessageComponent };
